import lang from "@/views/modules/StudyBudgets/language/en";
import breadcrumbs from "@/views/modules/StudyBudgets/MenuList.vue";
import Datepicker from 'vuejs-datepicker';

export default {
    name: "list-studybudgets",
   
    components: {
        breadcrumbs,
        Datepicker,
    },
    data() {
        return {
            page: 1,
            search: '',
            sort: {
                order: 'asc',
                column: 'date_entered',
            },
            perPage: 10,
            loading: true,
            templateList: [],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            lang:[],
           
        }
    },
    mounted() {
        this.getTemplate();
        this.lang = lang;
        this.dom_array = this.domArrayVariable;
    },
    methods: {
        changePage(page) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                self.getTemplate();
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            self.getTemplate();
        },
        getTemplate() {
            const self = this;
            self.loading = true;
             window.currentAction = 'list';
                axios.get('api/modules/studybudgets', {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function (response) {
                self.templateList = response.data.items;
              
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.getTemplate();
                } else {
                    self.loading = false;
                }
            }).catch(function () {
                self.loading = false;
            });
        },
        openDetail(urls, id){
            const self = this;
            let strdata = btoa(id);
            localStorage.setItem('budgetTempId', strdata);
            self.$router.push(urls);
        }
    }
}